module.exports = __webpack_public_path__ + "static/media/HL13.157bb3b5.jpg";